var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M473.655,423.724H38.345C17.167,423.724,0,406.557,0,385.379V126.621 c0-21.177,17.167-38.345,38.345-38.345h435.31c21.177,0,38.345,17.167,38.345,38.345V385.38 C512,406.557,494.833,423.724,473.655,423.724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M459.034,141.241v229.517H52.966V141.241H459.034"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#73AF00"
    },
    points: "52.966,141.241 256,256 52.966,370.759  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#73AF00"
    },
    points: "459.034,141.241 256,256 459.034,370.759  "
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF4B55"
    },
    cx: 256,
    cy: 256,
    r: 35.31
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M258.231,230.127l5.523,16.558l17.454,0.136c2.26,0.018,3.197,2.901,1.379,4.244l-14.041,10.369 l5.266,16.642c0.682,2.155-1.771,3.937-3.61,2.623L256,270.55l-14.2,10.151c-1.838,1.314-4.291-0.468-3.61-2.623l5.266-16.642 l-14.041-10.369c-1.818-1.343-0.881-4.226,1.379-4.244l17.454-0.136l5.523-16.558C254.484,227.983,257.516,227.983,258.231,230.127 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M257.319,99.992l3.263,9.783l10.313,0.079c1.335,0.01,1.889,1.715,0.814,2.507l-8.297,6.126 l3.111,9.833c0.403,1.273-1.047,2.326-2.133,1.549l-8.39-5.995l-8.391,5.997c-1.086,0.777-2.536-0.277-2.133-1.549l3.111-9.833 l-8.297-6.126c-1.074-0.793-0.521-2.497,0.814-2.507l10.313-0.079l3.263-9.783C255.104,98.726,256.896,98.726,257.319,99.992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M373.457,99.992l3.263,9.783l10.313,0.079c1.335,0.01,1.889,1.715,0.814,2.507l-8.297,6.126 l3.111,9.833c0.403,1.273-1.047,2.326-2.133,1.549l-8.391-5.997l-8.391,5.997c-1.086,0.777-2.536-0.277-2.133-1.549l3.111-9.833 l-8.297-6.126c-1.074-0.793-0.521-2.497,0.814-2.507l10.313-0.079l3.263-9.783C371.243,98.726,373.034,98.726,373.457,99.992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M141.181,99.992l3.263,9.783l10.313,0.079c1.335,0.01,1.889,1.715,0.814,2.507l-8.297,6.126 l3.111,9.833c0.403,1.273-1.047,2.326-2.133,1.549l-8.391-5.997l-8.391,5.997c-1.086,0.777-2.536-0.277-2.133-1.549l3.111-9.833 l-8.297-6.126c-1.074-0.793-0.521-2.497,0.814-2.507l10.313-0.079l3.263-9.783C138.966,98.726,140.758,98.726,141.181,99.992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M257.319,381.993l3.263,9.783l10.313,0.079c1.335,0.01,1.889,1.715,0.814,2.507l-8.297,6.126 l3.111,9.833c0.403,1.273-1.047,2.326-2.133,1.549l-8.39-5.995l-8.391,5.997c-1.086,0.777-2.536-0.277-2.133-1.549l3.111-9.833 l-8.297-6.126c-1.074-0.793-0.521-2.497,0.814-2.507l10.313-0.079l3.263-9.783C255.104,380.726,256.896,380.726,257.319,381.993z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M373.457,381.993l3.263,9.783l10.313,0.079c1.335,0.01,1.889,1.715,0.814,2.507l-8.297,6.126 l3.111,9.833c0.403,1.273-1.047,2.326-2.133,1.549l-8.391-5.997l-8.391,5.997c-1.086,0.777-2.536-0.277-2.133-1.549l3.111-9.833 l-8.297-6.126c-1.074-0.793-0.521-2.497,0.814-2.507l10.313-0.079l3.263-9.783C371.243,380.726,373.034,380.726,373.457,381.993z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M141.181,381.993l3.263,9.783l10.313,0.079c1.335,0.01,1.889,1.715,0.814,2.507l-8.297,6.126 l3.111,9.833c0.403,1.273-1.047,2.326-2.133,1.549l-8.391-5.997l-8.391,5.997c-1.086,0.777-2.536-0.277-2.133-1.549l3.111-9.833 l-8.297-6.126c-1.074-0.793-0.521-2.497,0.814-2.507l10.313-0.079l3.263-9.783C138.966,380.726,140.758,380.726,141.181,381.993z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M118.069,233.931H96V256c0,12.189,9.88,22.069,22.069,22.069s22.069-9.88,22.069-22.069 S130.258,233.931,118.069,233.931z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "140.138,278.069 128.007,275.718 118.069,256 137.786,265.938 "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGd);
export default __webpack_public_path__ + "static/media/gd.b65a5a345f0af211909a31b7c6c382a9.svg";
export { ForwardRef as ReactComponent };